export default "__VITE_ASSET__oC0PRom3__"